import { RecHoldingsView } from "./rec-holdings-view";
import { useRecHoldings } from "./use-rec-holdings";

export const RecHoldings = () => {
  const logic = useRecHoldings();

  return <RecHoldingsView {...logic} />;
};
